import React, { useState, useEffect } from "react";
import { FiInfo } from "react-icons/fi"; // ✨ ایمپورت آیکون اینفو
import "./Page2Properties.css";

export default function Page2Properties({ onNext, onPrev, initialData, business_id }) {
  const [property1, setProperty1] = useState("");
  const [property2, setProperty2] = useState("");
  const [subProps1, setSubProps1] = useState([]);
  const [subProps2, setSubProps2] = useState([]);

  const [isEditing1, setIsEditing1] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [title1, setTitle1] = useState("نام خصوصیت اول");
  const [title2, setTitle2] = useState("نام خصوصیت دوم");
  const [tempTitle1, setTempTitle1] = useState("نام خصوصیت اول");
  const [tempTitle2, setTempTitle2] = useState("نام خصوصیت دوم");

  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const [isSimpleProduct, setIsSimpleProduct] = useState(false);

  useEffect(() => {
    if (initialData) {
      setTitle1(initialData.title1 || "نام خصوصیت اول");
      setTitle2(initialData.title2 || "نام خصوصیت دوم");
      setSubProps1(initialData.subProps1 || []);
      setSubProps2(initialData.subProps2 || []);
      
      if (initialData.subProps1 && initialData.subProps1.length === 0 && initialData.subProps2 && initialData.subProps2.length === 0) {
        setIsSimpleProduct(true);
      }
    }
  }, [initialData]);

  const addSubProp1 = () => {
    if (property1.trim() !== "") {
      setSubProps1([...subProps1, property1.trim()]);
      setProperty1("");
    }
  };

  const addSubProp2 = () => {
    if (property2.trim() !== "") {
      setSubProps2([...subProps2, property2.trim()]);
      setProperty2("");
    }
  };

  const removeSubProp1 = (item) => {
    setSubProps1(subProps1.filter((i) => i !== item));
  };

  const removeSubProp2 = (item) => {
    setSubProps2(subProps2.filter((i) => i !== item));
  };

  const handleKeyPress1 = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addSubProp1();
    }
  };

  const handleKeyPress2 = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addSubProp2();
    }
  };

  const startEditing1 = () => {
    setTempTitle1(title1 === "نام خصوصیت اول" ? "" : title1);
    setIsEditing1(true);
  };

  const startEditing2 = () => {
    setTempTitle2(title2 === "نام خصوصیت دوم" ? "" : title2);
    setIsEditing2(true);
  };

  const saveTitle1 = () => {
    if (tempTitle1.trim() !== "") {
      setTitle1(tempTitle1.trim());
    } else {
      setTitle1("نام خصوصیت اول");
    }
    setIsEditing1(false);
  };

  const saveTitle2 = () => {
    if (tempTitle2.trim() !== "") {
      setTitle2(tempTitle2.trim());
    } else {
      setTitle2("نام خصوصیت دوم");
    }
    setIsEditing2(false);
  };
  
  const cancelEditing1 = () => {
    setIsEditing1(false);
    setTempTitle1(title1);
  };

  const cancelEditing2 = () => {
    setIsEditing2(false);
    setTempTitle2(title2);
  };

  const handleKeyPressTitle1 = (e) => {
    if (e.key === 'Enter') {
      saveTitle1();
    } else if (e.key === 'Escape') {
      cancelEditing1();
    }
  };

  const handleKeyPressTitle2 = (e) => {
    if (e.key === 'Enter') {
      saveTitle2();
    } else if (e.key === 'Escape') {
      cancelEditing2();
    }
  };

  const handleNext = () => {
    if (isSimpleProduct) {
      onNext({
        title1: title1,
        title2: title2,
        subProps1: [],
        subProps2: []
      });
    } else {
      // بررسی اجباری بودن تعریف ویژگی
      if (subProps1.length === 0 && subProps2.length === 0) {
        alert("لطفاً حداقل یک ویژگی برای محصول تعریف کنید. اگر کالا ویژگی خاصی ندارد، تیک «این کالا بدون ویژگی می‌باشد» را بزنید.");
        return;
      }
      
      onNext({
        title1: title1,
        title2: title2,
        subProps1: subProps1,
        subProps2: subProps2
      });
    }
  };

  const handlePrev = () => {
    const currentData = {
      title1: title1,
      title2: title2,
      subProps1: isSimpleProduct ? [] : subProps1,
      subProps2: isSimpleProduct ? [] : subProps2
    };
    onPrev(currentData);
  };

  return (
    <div className="p2-container" dir="rtl">
      
      <div className="p2-top-controls">
        <label className="p2-simple-checkbox-label">
          <input 
            type="checkbox" 
            className="p2-hidden-checkbox"
            checked={isSimpleProduct}
            onChange={(e) => setIsSimpleProduct(e.target.checked)}
          />
          <div className="p2-custom-checkbox">
            {isSimpleProduct && (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            )}
          </div>
          <span className="p2-checkbox-text">این کالا بدون ویژگی می‌باشد</span>
        </label>

        <button 
          className={`p2-help-icon-btn ${isHelpOpen ? 'active' : ''}`} 
          onClick={() => setIsHelpOpen(!isHelpOpen)}
          type="button"
          title="راهنما"
        >
          <FiInfo size={22} />
        </button>
      </div>

      <div className={`p2-help-box ${isHelpOpen ? 'open' : ''}`}>
        <p className="p2-info">
          برای هر محصول می‌توانید ۲ خصوصیت تعریف نمایید. اسامی خصوصیت‌ها توسط شما نوشته می‌شود
          و خصوصیت دوم زیرشاخه‌ی خصوصیت اول می‌باشد.
          <br />
          <strong>مثال:</strong>
          <br />
          خصوصیت اول: رنگ
          <br />
          خصوصیت دوم: سایز
          <br />
          رنگ آبی، سایز: L , XL , XXL
        </p>
      </div>

      {!isSimpleProduct && (
        <div className="p2-properties-wrapper">
          <div className="p2-section">
            <div className="p2-field">
              <div className="p2-title-wrapper">
                {isEditing1 ? (
                  <div className="p2-title-edit">
                    <input
                      className="p2-title-input"
                      value={tempTitle1}
                      onChange={(e) => setTempTitle1(e.target.value)}
                      onKeyPress={handleKeyPressTitle1}
                      onBlur={saveTitle1}
                      autoFocus
                    />
                    <div className="p2-title-actions">
                      <button className="p2-title-save" onClick={saveTitle1}>✓</button>
                      <button className="p2-title-cancel" onClick={cancelEditing1}>✕</button>
                    </div>
                  </div>
                ) : (
                  <div className="p2-title-display">
                    <label className="p2-label">{title1}</label>
                    <button className="p2-edit-btn" onClick={startEditing1} title="ویرایش عنوان">✎</button>
                  </div>
                )}
              </div>

              <div className="p2-add-group">
                <input
                  className="p2-input"
                  value={property1}
                  onChange={(e) => setProperty1(e.target.value)}
                  onKeyPress={handleKeyPress1}
                  placeholder="مثلاً رنگ"
                />
                <button className="p2-btn-add" type="button" onClick={addSubProp1}>افزودن</button>
              </div>
            </div>

            <div className="p2-sublist">
              {subProps1.length > 0 && <span className="p2-values-label">مقادیر:</span>}
              <div className="p2-tags">
                {subProps1.map((item, index) => (
                  <div key={index} className="p2-tag">
                    <span>{item}</span>
                    <button type="button" className="p2-delete" onClick={() => removeSubProp1(item)} title="حذف">✕</button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="p2-section">
            <div className="p2-field">
              <div className="p2-title-wrapper">
                {isEditing2 ? (
                  <div className="p2-title-edit">
                    <input
                      className="p2-title-input"
                      value={tempTitle2}
                      onChange={(e) => setTempTitle2(e.target.value)}
                      onKeyPress={handleKeyPressTitle2}
                      onBlur={saveTitle2}
                      autoFocus
                    />
                    <div className="p2-title-actions">
                      <button className="p2-title-save" onClick={saveTitle2}>✓</button>
                      <button className="p2-title-cancel" onClick={cancelEditing2}>✕</button>
                    </div>
                  </div>
                ) : (
                  <div className="p2-title-display">
                    <label className="p2-label">{title2}</label>
                    <button className="p2-edit-btn" onClick={startEditing2} title="ویرایش عنوان">✎</button>
                  </div>
                )}
              </div>

              <div className="p2-add-group">
                <input
                  className="p2-input"
                  value={property2}
                  onChange={(e) => setProperty2(e.target.value)}
                  onKeyPress={handleKeyPress2}
                  placeholder="مثلاً سایز"
                />
                <button className="p2-btn-add" type="button" onClick={addSubProp2}>افزودن</button>
              </div>
            </div>

            <div className="p2-sublist">
              {subProps2.length > 0 && <span className="p2-values-label">مقادیر:</span>}
              <div className="p2-tags">
                {subProps2.map((item, index) => (
                  <div key={index} className="p2-tag">
                    <span>{item}</span>
                    <button type="button" className="p2-delete" onClick={() => removeSubProp2(item)} title="حذف">✕</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {isSimpleProduct && (
        <div className="p2-simple-product-message">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="p2-simple-icon">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <p>این کالا بدون ویژگی ثبت خواهد شد.</p>
          <span>برای رفتن به مرحله بعد، روی دکمه زیر کلیک کنید.</span>
        </div>
      )}

      <div className="p2-button-wrapper">
        <button className="p2-prev-btn" onClick={handlePrev}>
          <span className="p2-btn-icon">←</span>
          مرحله قبل
        </button>

        <button className="p2-next-btn" onClick={handleNext}>
          مرحله بعد
          <span className="p2-btn-icon">→</span>
        </button>
      </div>
    </div>
  );
}
